import type { LegalLandDescriptionIO } from '@/api';

export default class LegalLandDescription implements LegalLandDescriptionIO {
    MER = '';
    RGE = '';
    TWP = '';
    SEC = '';
    QTR = '';
    LSD = '';
    Plan = '';
    Block = '';
    Lot = '';
    PBL: string | null = null;
    ATS: string | null = null;

    constructor(data?: LegalLandDescriptionIO) {
        Object.assign(this, data);

        // calculate PBL
        if (this.Plan.length === 0 || this.Block.length === 0 || this.Lot.length === 0) {
            this.PBL = null;
        } else {
            this.PBL = `${this.Plan}-${this.Block}-${this.Lot}`;
        }

        // calculate ATS
        if (this.MER.length === 0 || this.RGE.length === 0 || this.SEC.length === 0) {
            this.ATS = null;
        } else {
            let str = `W${this.MER}-${this.RGE}-${this.TWP}-${this.SEC}`;
            if (this.QTR) {
                str = `${str}-${this.QTR}`;
                if (this.LSD) {
                    str = `${str}-${this.LSD}`;
                }
            }
            this.ATS = str.trim();
        }
    }
}
